import React from 'react';
import Type from 'prop-types';
import { Avatar, Box, Typography } from "@mui/material";
import { getInitials } from 'utils/string';
import styles from './HeaderAccount.module.css';

export const HeaderAccount = (props) => {
  const { onClick, userInfo } = props;
  const { fullName: userFullName, jobTitle: userJobTitle } = userInfo;
  const userInitials = getInitials(userFullName);

  return (
    <Box className={styles.account} py={3} px={2} onClick={onClick}>
      <Avatar alt={userFullName} className={styles.accountAvatar}>
        {userInitials}
      </Avatar>
      <div className={styles.accountContent}>
        <Typography
          className={styles.accountName}
          component="div"
          variant="body1"
          sx={{ fontWeight: 500 }}
        >
          {userFullName}
        </Typography>
        <Typography component="div" variant="body1">
          {userJobTitle}
        </Typography>
      </div>
    </Box>
  );
};

const userInfo = {
  fullName: Type.string.isRequired,
  jobTitle: Type.string.isRequired,
};

HeaderAccount.propTypes = {
  onClick: Type.func.isRequired,
  userInfo: Type.shape(userInfo).isRequired,
};
